module.exports = __webpack_public_path__ + "static/media/alaska_mototurismo_1.c6578199.jpg";